var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-loader py-5 text-center"},[_c('div',{staticClass:"spinner-grow spinner-grow--color text-secondary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])
}]

export { render, staticRenderFns }